<form [formGroup]="form">
  <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
    <mat-form-field class="full-width" *ngIf="requiredCurrentPassword">
      <mat-label>{{ 'fos.current_password' | translate }}</mat-label>
      <input matInput data-cy="current_password" type="password" [formControl]="form.controls['current_password']"
        placeholder="{{ 'fos.current_password' | translate }}" [type]="hide.current_password ? 'password' : 'text'">
      <mat-icon matSuffix (click)="hide.current_password = !hide.current_password">{{hide.current_password ?
        'visibility_off' : 'visibility'}}</mat-icon>

      <mat-error *ngIf="form.controls['current_password'].invalid && form.controls['current_password'].touched"
        [flexFormControlError]="form.controls['current_password']" [customMessages]="{
          current_password_incorrect: 'user.validators.current_password_incorrect'|translate
        }"></mat-error>
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>{{ 'fos.new_password' | translate }}</mat-label>
      <input matInput data-cy="password" type="password" [formControl]="form.controls['password']"
        placeholder="{{ 'fos.new_password' | translate }}" [type]="hide.password ? 'password' : 'text'">
      <mat-icon matSuffix (click)="hide.password = !hide.password">{{hide.password ? 'visibility_off' :
        'visibility'}}</mat-icon>

      <mat-error *ngIf="form.controls['password'].invalid && form.controls['password'].touched"
        [flexFormControlError]="form.controls['password']" [customMessages]="{
          password_constraint: 'user.validators.password_constraint'|translate,
          password_same_current: 'user.validators.password_same_current'|translate
        }"></mat-error>
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>{{ 'fos.new_password_confirmation' | translate }}</mat-label>
      <input matInput data-cy="confirm_password" type="password" [formControl]="form.controls['confirm_password']"
        placeholder="{{ 'fos.new_password_confirmation' | translate }}"
        [type]="hide.confirm_password ? 'password' : 'text'">
      <mat-icon matSuffix (click)="hide.confirm_password = !hide.confirm_password">{{hide.confirm_password ?
        'visibility_off' : 'visibility'}}</mat-icon>

      <mat-error *ngIf="form.controls['confirm_password'].invalid && form.controls['confirm_password'].touched"
        [flexFormControlError]="form.controls['confirm_password']" [customMessages]="{
          password_not_match: 'user.validators.confirm_password_not_match'|translate,
          mustMatch: 'user.validators.confirm_password_not_match'|translate,
          'any.only': 'user.validators.confirm_password_not_match'|translate
        }"></mat-error>
    </mat-form-field>

  </div>
</form>
